export const NEW_DOMAIN_WITH_PATH = 'https://tennisballcricket/_new'
export const LEGACY_DOMAIN = 'https://tennisballcricket.com';
export const API_BASE_URL = 'https://api.tennisballcricket.com/v1';

export const AWARD_ABBR_LOOKUP = [
    {"AR": "Best All Rounder"},

]

export function GET_AWARD_ABBR(key) {
    const entry = AWARD_ABBR_LOOKUP.find(item => Object.keys(item)[0] === key);
    if (entry) {
      return entry[key];
    } else {
      return null; // Key not found
    }
  }